<template>
  <div class="w-full h-200px text-center">
    <p>It seems like there are no results, try again different keywords</p>
  </div>
</template>

<script></script>
